import { useState, useRef, useEffect } from 'react';

interface BoldPrefixInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  className: string;
}

export function BoldPrefixInput({ value, onChange, placeholder, className }: BoldPrefixInputProps) {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  if (isEditing || !value) {
    return (
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={onChange}
        onBlur={() => setIsEditing(false)}
        placeholder={placeholder}
        className={className}
      />
    );
  }

  const colonIndex = value.indexOf(':');

  return (
    <div
      onClick={() => setIsEditing(true)}
      className={`${className} cursor-text bg-white truncate`}
    >
      {colonIndex > -1 ? (
        <>
          <span className="font-bold text-gray-900">{value.slice(0, colonIndex + 1)}</span>
          <span>{value.slice(colonIndex + 1)}</span>
        </>
      ) : (
        value
      )}
    </div>
  );
}
